import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Menu } from 'semantic-ui-react';
// import debug from 'debug';

import NavDropdownMenu from './NavDropdownMenu';
import NavMenuItem from './NavMenuItem';
import NavMenuIconGroup from './NavMenuIconGroup';
import DesktopTeamMenu from './DesktopTeamMenu';
import MenuType from '../../../../lib/proptypes/menu.proptypes';
import TeamsType from '../../../../lib/proptypes/teams';
import * as teamsSelectors from '../../../../store/reducers/teams.selectors';
import { TEAMS_NAV_KEY } from '../../../../store/actions/nav.types';
import classes from './desktopNav.css';

// const log = debug('huddle:app:nav:desktop');

class DesktopNav extends PureComponent {
  static propTypes = {
    menu: MenuType.isRequired,
    teams: TeamsType.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      xPageOffset: null,
    };
  }

  calcTeamsPosition = node => {
    if (node && !this.state.xOffset) {
      // eslint-disable-next-line react/no-find-dom-node
      const xPos = ReactDOM.findDOMNode(node).getBoundingClientRect().left;
      const xPageOffset = xPos - ((document.body.offsetWidth - 1000) / 2);
      this.setState({ xPageOffset });
    }
  };

  menuItemFactory = ({ item, teams }) => {
    // Teams menu item doesn't have children
    if (item.children && item.children.length) {
      return <NavDropdownMenu key={item.key} item={item} />;
    }
    if (item.key === TEAMS_NAV_KEY) {
      return (
        <NavDropdownMenu
          key={item.key}
          item={item}
          ref={this.calcTeamsPosition}
          offset={this.state.xPageOffset}
        >
          <DesktopTeamMenu teams={teams} />
        </NavDropdownMenu>
      );
    }
    return <NavMenuItem key={item.key} item={item} />;
  };

  render = () => {
    const { menu, teams } = this.props;

    return (
      <Menu
        inverted
        attached
        size="large"
        className={classes.primaryNav}
      >
        {menu.map(item => this.menuItemFactory({ item, teams }))}
        <NavMenuIconGroup />
      </Menu>
    );
  };
}

const mapStateToProps = state => ({
  menu: state.nav.primary,
  // TODO: add reselect here to memoize the call
  teams: teamsSelectors.selectTeamsHierarchy(state),
});

export default connect(mapStateToProps)(DesktopNav);



// WEBPACK FOOTER //
// ./src/app/components/Nav/DesktopNav/DesktopNav.js